export default __webpack_public_path__ + "static/illustration-business.url-80b8b71824941f40f13f18b109bd60bd.svg";